import { Center, CenterProps, Tooltip } from '@chakra-ui/react'
import { Visibility_Enum } from '@gql'
import { VisibleObjectType } from '@rolebase/shared/model/visibility'
import React from 'react'
import {
  VisibilityCircleIcon,
  VisibilityOrgIcon,
  VisibilityRoleIcon,
} from 'src/icons'
import useVisibilitySentence from '../hooks/useVisibilitySentence'

interface Props extends CenterProps {
  objectType: VisibleObjectType
  circleId?: string
  // Not `visibility`: that name is a CSS style prop on Chakra components.
  level: Visibility_Enum
  size?: number
  // Lists only mark the restricted level, as the lock marked « private »
  // before; headers show every level.
  onlyRole?: boolean
}

const icons = {
  [Visibility_Enum.Role]: VisibilityRoleIcon,
  [Visibility_Enum.Circle]: VisibilityCircleIcon,
  [Visibility_Enum.Org]: VisibilityOrgIcon,
}

// The level of an object, as an icon whose tooltip is the sentence of the edit
// screen (CONF-02).
//
// The hidden case returns before the sentence is computed: lists render one
// icon per row, and most rows are not at the Role level (review of 14/09/2026).
export default function VisibilityIcon({ onlyRole, ...props }: Props) {
  if (onlyRole && props.level !== Visibility_Enum.Role) return null
  return <ShownVisibilityIcon {...props} />
}

function ShownVisibilityIcon({
  objectType,
  circleId,
  level,
  size = 18,
  ...centerProps
}: Omit<Props, 'onlyRole'>) {
  const sentence = useVisibilitySentence(objectType, circleId, level)
  const Icon = icons[level]

  return (
    <Tooltip label={sentence} hasArrow>
      <Center {...centerProps}>
        <Icon size={size} />
      </Center>
    </Tooltip>
  )
}
